import styled from "styled-components";

interface IProps {
  isDisabled: boolean;
  inline?: boolean;
}
const Disabled = styled.div`
  ${({ inline = true }: IProps) => (inline ? `display: inline-block;` : ``)};
  * {
    ${({ isDisabled }: IProps) =>
      isDisabled
        ? `
    pointer-events: none;
    opacity: 0.6;
    `
        : ``};
  }
`;

export default Disabled;



// WEBPACK FOOTER //
// ./src/components/common/Disabled.tsx